// extracted by mini-css-extract-plugin
module.exports = {"componentsPaymentMethodRender":"styles_componentsPaymentMethodRender__3SnU7"};